import request from "@/utils/request"

//获取收件箱
export function getMessageInbox(params) {
    return request({
        method: 'post',
        url: 'actual/message/inbox/',
        data: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//获取发件箱
export function getMessageOutbox(params) {
    return request({
        method: 'get',
        url: 'actual/message/outbox/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//获取信息内容
export function getMessageInfoContent(params) {
    return request({
        method: 'get',
        url: 'actual/message/info/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}
//获取所有用户
export function getUsers() {
    return request({
        method: 'get',
        url: 'actual/getusers/',
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//发送私信
export function getMessageSendInfo(data) {
    return request({
        method: 'post',
        url: 'actual/message/info/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}
//清空收件箱
export function deleteMessageInbox() {
    return request({
        method: 'delete',
        url: 'actual/message/inbox/',
        headers: {
            token: localStorage.getItem("token")
        }
    })

}
//清空发件箱
export function deleteMessageOutbox() {
    return request({
        method: 'delete',
        url: 'actual/message/outbox/',
        headers: {
            token: localStorage.getItem("token")
        }
    })

}
//删除指定邮件
export function deleteMessageInfo(data) {
    return request({
        method: 'delete',
        url: 'actual/message/info/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//查看我提交的所有数据
export function getQuestionsSubmit(params) {
    return request({
        method: 'get',
        url: 'actual/question/list/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//提交问题
export function sendQuestionList(data) {
    return request({
        method: 'post',
        url: 'actual/question/submit/',
        data,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}

//获取问题具体信息
export function getQuestionSubmit(params) {
    return request({
        method: 'get',
        url: 'actual/question/submit/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })

}


// WEBPACK FOOTER //
// ./src/api/message.js